<script setup>
definePage({ meta: { layout: 'manse', public: true } });

const router = useRouter();

// 탈퇴 플로우에서 앱/웹 상태 정리가 이미 완료되었으므로 여기선 네비게이션만 수행
const goToHome = () => {
  router.push('/main');
};
const goToSaju = () => {
  router.push('/saju-input');
};

onMounted(() => {
  history.pushState(null, null, location.href);
  window.onpopstate = () => {
    history.go(1);
  };
});

onUnmounted(() => {
  // onpopstate 리스너 제거
  window.onpopstate = null;
});
</script>

<template>
  <div class="withdraw-body">
    <div class="notice-withdraw">
      <div class="top">
        <div class="logo"></div>
        <div class="tit">회원 탈퇴가 완료되었습니다</div>
        <div class="txt">
          낭만만세력을 이용해주셔서 감사합니다.<br />
          더 나은 서비스로 찾아뵙겠습니다
        </div>
        <div @click="goToSaju" class="guest-mode">게스트로 만세력 보기</div>
      </div>
      <button class="home" @click="goToHome">홈으로 이동</button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.withdraw-body {
  padding-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  .notice-withdraw {
    width: 560px;
    height: 431px;
    display: inline-flex;
    padding: 60px 80px;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    border-radius: 20px;
    border: 1px solid var(--Gray-300, #ebebeb);
    background: var(--gray-100-white, #fff);
    .logo {
      background: url('@manseImages/logo_b.png') center center no-repeat;
      width: 140px !important;
      height: 53px !important;
      background-size: contain;
      margin-bottom: 40px;
    }
    .tit {
      color: var(--gray-900-black, #2c2c2e);
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .txt {
      color: var(--Gray-700, #575757);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.375px;
      margin-bottom: 32px;
    }
    .guest-mode {
      cursor: pointer;
      color: var(--orange-300-main, #eb4c10);
      text-align: center;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: -0.35px;
      text-decoration-line: underline;
    }
    .home {
      display: flex;
      width: 400px;
      padding: 14px 20px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 6px;
      background: var(--orange-300-main, #eb4c10);
      color: var(--gray-100-white, #fff);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }
  }
}
.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .withdraw-body {
    padding: 0;
    padding-bottom: var(--safe-area-bottom, 0px);
    height: calc(100dvh - var(--safe-area-top, 0px));
    background-color: #fff;

    .notice-withdraw {
      width: 100%;
      height: 100%;
      padding: 40px 16px 40px;
      border: none;
      border-radius: 0;
      box-sizing: border-box;
      justify-content: center;

      .home {
        width: 100%;
        max-width: 400px;
      }
    }
  }
}
</style>
